import { IGatsbyImageData } from 'gatsby-plugin-image';

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const hasGatsbyImageData = <T>(candidate: any): candidate is T & { image: IGatsbyImageData } => (
  Boolean(candidate?.image?.width)
  && Boolean(candidate?.image?.height)
  && Boolean(candidate?.image?.images)
);
export default hasGatsbyImageData;
